<ng-container *ngIf="routingInProgress$ | async; else ready">
  <ish-loading></ish-loading>
</ng-container>

<ng-template #ready>
  <h1 class="text-center text-capitalize font-50 my-4">Customer Login</h1>
  <div class="container-fluid">
    <div class="row justify-content-center " data-testing-id="account-login-page">
      <div class="col-lg-6 border p-3">
        <div class="mb-2">
          <div *ngIf="(isLoggedIn$ | async) !== true">
            <h1 class="h2">{{ 'account.login.signin.heading' | translate }}</h1>
            <p *ngIf="loginMessageKey$ | async as loginMessageKey" class="alert alert-info">
              {{ loginMessageKey | translate }}
            </p>

            <ish-identity-provider-login></ish-identity-provider-login>
          </div>
        </div>
        <div class="mb-0">
          <h2 class="registered-cutomer-header">{{ 'dias.account.new_user.heading' | translate }}</h2>
          <p>{{ 'account.create.benefit.text' | translate }}</p>
          <a class="btn btn-primary" routerLink="/register" [queryParams]="{ returnUrl: '/account' }">{{
            'dias.account.create.button.label' | translate }}
          </a>
        </div>
      </div>


    </div>
  </div>

</ng-template>